import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Paper } from "@material-ui/core";
import CreateInventoryItem from "./CreateInventoryItem";
import UpdateInventoryItem from "./UpdateInventoryItem";
import InventoryReconcile from "./InventoryReconcile";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px",
    margin: "20px",
    textAlign: "left",
    minHeight: "200px",
    width: "100%",
    backgroundColor: "#e0e0e0",
  },
  itemCard: {
    padding: 15,
    margin: 10,
  },
  itemNombre: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    marginBottom: 8,
  },
}));

export default function EventInventoryContainer() {
  const classes = useStyles();
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const inventarios = registryConfiguration.inventarios || {};

  return (
    <Paper className={classes.paper}>
      <Grid container direction="row" alignItems="flex-start" spacing={2}>
        <Grid item xs={12}>
          <Typography gutterBottom variant={"h2"} component="h2">
            Inventario de items
          </Typography>
          <Typography gutterBottom variant={"body1"}>
            Controla existencias de tallas u otras opciones de campos, y de
            productos adicionales.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <CreateInventoryItem />
        </Grid>

        {Object.keys(inventarios).map((itemKey) => {
          const item = inventarios[itemKey];
          return (
            <Grid item xs={12} sm={6} key={itemKey}>
              <Paper className={classes.itemCard}>
                <Typography className={classes.itemNombre}>
                  {item.nombre}
                </Typography>
                {Object.values(item.opciones || {}).map((opcion, i) => {
                  const disponible =
                    (Number(opcion.capacidad) || 0) - (opcion.vendidos || 0);
                  return (
                    <Typography key={i} variant="body2">
                      {opcion.nombre}: {opcion.vendidos || 0} vendidos /{" "}
                      {opcion.capacidad || 0} capacidad — Disponible:{" "}
                      {disponible}
                      {opcion.agotado ? " (AGOTADO)" : ""}
                    </Typography>
                  );
                })}
                <UpdateInventoryItem itemKey={itemKey} item={item} />
              </Paper>
            </Grid>
          );
        })}

        <Grid item xs={12}>
          <InventoryReconcile />
        </Grid>
      </Grid>
    </Paper>
  );
}
